import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import Table from 'UI/Table'
import SubMenu from 'FoundationalComponents/AssetSubMenus/Vcenter'
import { map, compact, sortBy, uniq } from 'lodash'

import { VcenterReportFilters as Filters, filteredData } from './Filters';

const VcenterAssetReportVcenters = ({ vcenters, locations }) => {
  const filterOptions = {
    locations: map(compact(locations), ({ id, name }) => ({ label: name, value: id })),
    customers: map(sortBy(uniq(compact(map(vcenters, 'customer_name')))), (name) => ({ label: name, value: name }))
  }
  const [filters, changeFilters] = useState({
    locations: 'all',
    customers: 'all'
  })

  const columns = [
    { Header: 'Name', accessor: 'name', Cell: ({ original }) => (
      <>
        <SubMenu vcenter={original} />
        <i style={{ fontSize: 'small' }}>{original.asset_label}</i>
      </>
    ) },
    { Header: 'Customer', accessor: 'customer_name', type: 'clientNameWithStatus' },
    { Header: 'Clusters', accessor: 'cluster_count', type: 'number', width: 120 },
    { Header: 'Hosts', accessor: 'host_count', type: 'number', width: 120 },
    { Header: 'VMs', accessor: 'vm_count', type: 'number', width: 120 },
    { Header: 'FQDN', accessor: 'fqdn' },
    { Header: 'IP', accessor: 'ip' },
    { Header: 'SSL expires in', accessor: 'ssl_cert_expires_in', Cell: (row) => {
      return (
        <div style={{ color: row.value >= 90 ? 'green' : row.value >= 30 && row.value < 90 ? 'orange' : 'red', textAlign: 'center' }}>
          {row.value != 0 } {row.value + ' days'}
        </div>
      )
    } },
    { Header: 'Avoid Weak Block Ciphers', accessor: 'ssl_cert_avoid_weak_block_ciphers', Cell: (row) => {
      return (
        <div style={{ color: row.value === 'pass' ? 'green' : row.value === 'fail' ? 'red' : 'orange', textAlign: 'center' }}>
          {row.value}
        </div>
      )
    } },
    { Header: 'Avoid Weak SSL & TLS Versions', accessor: 'ssl_cert_avoid_weak_ssl_and_tls_versions', Cell: (row) => {
      return (
        <div style={{ color: row.value === 'pass' ? 'green' : row.value === 'fail' ? 'red' : 'orange', textAlign: 'center' }}>
          {row.value}
        </div>
      )
    } },
    { Header: 'Platform EOL', accessor: 'platform_eol_check', Cell: (row) => {
      return (
        <div style={{ color: row.value === 180 ? 'green' : row.value === 30 ? 'orange' : 'red', textAlign: 'center'  }}>
          {row.value != 0 && '>'} {row.value + ' days'}
        </div>
      )
     } },
    { Header: 'Mondoo', accessor: 'mondoo_active', width: 90, type: 'boolean' },
    { Header: 'Mondoo Vulnerabilities', accessor: 'mondoo_vulnerabilities', type: 'number', width: 120, Cell: (row) => {
      return (
        <div style={{ color: row.value === 0 ? 'green' : 'red', textAlign: 'center ' }}>
          {row.value}
        </div>
      )
    } },
  ]

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, filterOptions }} />

      <Table {...{
        data: filteredData({ vcenters, filters }),
        columns:  columns,
        tableProps: {
          minRows:  0,
          filterable: true,
          defaultSorted: [{ id: 'name', asc: true }],
        }
      }}/>
    </Fragment>
  )
}

export default VcenterAssetReportVcenters
